<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'export-offers'">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbMenuItems" [home]="breadcrumbHome"></p-breadcrumb>
  <div style="margin-top: 30px;">
    <app-payments-component [importOrderId]="importOrderId"></app-payments-component>
  </div>
</app-user-dashboard>
